import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateSearchComponent } from "../../templates/template-search/template-search.component";
import { SelectGroup, SelectOption } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idv",
  imports: [TemplateSearchComponent],
  templateUrl: "./prefix-idv.component.html",
  styleUrl: "./prefix-idv.component.less",
})
export class PrefixIdvComponent extends PrefixComponent<string> {
  @Input()
  public groups: SelectGroup[];

  @Input()
  public options: SelectOption[];

  public constructor() {
    super();
    this.groups = [];
    this.options = [];
    this.options.unshift({ label: "-?-", value: "null" });
    this.characters = ALLOWED_CHARACTERS["idv"];
  }
}
